import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {OAuthService} from 'angular-oauth2-oidc';
import {PortalIdpService} from '../services/portal-idp.service';
import {environment} from '../../environments/environment';
import {CommonModule} from '@angular/common';
import {FooterComponent} from './footer/footer.component';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'login-page',
  templateUrl: 'login-page.component.html',
  styleUrls: ['login-page.component.scss'],
  imports: [CommonModule, FooterComponent, FormsModule]
})
export class LoginPageComponent {
  idp: string
  basehost = environment.production ? '.content.castlabs.com' : '.content-stag.castlabs.com';

  readonly localDev = environment.localDev;
  readonly hasEnv = !!environment.env_name;
  localEnvInput: string = localStorage.getItem('local-dev-env') ?? '';

  constructor(public oAuthService: OAuthService, public router: Router, portalIdp: PortalIdpService) {
    this.idp = portalIdp.getIdpName()
    const postLogoutPath = sessionStorage.getItem('post-logout-path');
    if (postLogoutPath) {
      history.replaceState(null, '', location.pathname + '#' + postLogoutPath);
    }
  }

  login() {
    const postLogoutPath = sessionStorage.getItem('post-logout-path');
    this.oAuthService.initLoginFlow(postLogoutPath || this.router.url, {});
  }

  selectEnv(): void {
    const env = this.localEnvInput.trim();
    if (!env) return;
    localStorage.setItem('local-dev-env', env);
    window.location.reload();
  }

  protected readonly window = window;
  protected readonly location = location;
}
